import { render } from "./Term.vue?vue&type=template&id=3c8bc572&scoped=true"
import script from "./Term.vue?vue&type=script&lang=js"
export * from "./Term.vue?vue&type=script&lang=js"

import "./Term.vue?vue&type=style&index=0&id=3c8bc572&scoped=true&lang=css"

import exportComponent from "/Users/user/Desktop/personal_projects/music_quiz/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8bc572"]])

export default __exports__